/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Kind_IncomeInputs */

const vi_expense_kind_income = /** @type {(inputs: Expense_Kind_IncomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Thu`)
};

/**

* @param {Expense_Kind_IncomeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_kind_income = /** @type {((inputs?: Expense_Kind_IncomeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Kind_IncomeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_kind_income(inputs)
});